<script>
import Phone from '@wielink-application/shared/vue/components/form/horizontal/phone.vue'

export default Phone;
</script>